import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import AppBar from "../partials/AppBar";
import _cookies from "../../shared/utils/_cookies";

import { useMaintainLogon } from "../../features/auth/logon";
import isMobile from "../../shared/utils/isMobile";

function ProtectedRoutesLayout({ children, AppBarProps, ...props }) {
  useMaintainLogon({
    params: {
      studentId: _cookies.getItem("auth")?.user?.alunoid,
      isApp: isMobile() ? "S" : "N",
      courseId: 0,
    },
  });
  return (
    <>
      <AppBar {...AppBarProps} />

      <Box
        id="pr_layout_container"
        sx={{
          display: "flex",
          flexDirection: "row",
          height: "calc(100dvh - 64px)",
        }}
      >
        {/* <Chat /> */}
        <Outlet />
      </Box>
    </>
  );
}

export default ProtectedRoutesLayout;
